import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNL = function FlagNL() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#A2001D",
    d: "M25 0C14.251 0 5.088 6.784 1.555 16.304h46.89C44.913 6.784 35.75 0 25 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M25 50c10.75 0 19.913-6.784 23.445-16.304H1.555C5.088 43.216 14.251 50 25 50Z"
  }));
};
FlagNL.displayName = 'FlagNL';
export default withFlagWrapper(FlagNL);
//# sourceMappingURL=index.js.map